export const ItemTypes = {
    SOUND_LETTER: 'soundletter'
  }